var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"qa-card"},[_c('h2',{staticClass:"qa-card__title"},[_vm._v(_vm._s(_vm.questionObj.QTwo))]),_c('QaAnswerContent',{staticClass:"qa-answer",attrs:{"blocks":_vm.questionObj.Ans}}),_c('QaFeedback',{attrs:{"type":"official_qa_helpful","cause":_vm.questionObj.QTwo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }